
module.exports = require("./src/index.ts").default;
module.exports.addTokenPositions = require("./src/index.ts").addTokenPositions;
